import { render } from "./PaymentCart.vue?vue&type=template&id=5e35df73"
import script from "./PaymentCart.vue?vue&type=script&lang=js"
export * from "./PaymentCart.vue?vue&type=script&lang=js"

import "./PaymentCart.vue?vue&type=style&index=0&id=5e35df73&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__